import { render, staticRenderFns } from "./VatPaymentModal.vue?vue&type=template&id=5ec84939&scoped=true&"
import script from "./VatPaymentModal.vue?vue&type=script&lang=js&"
export * from "./VatPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec84939",
  null
  
)

export default component.exports